import React from 'react';
import { LogOutIcon, AlertTriangleIcon } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { useAuth } from '../App';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ImpersonationBanner = () => {
  const { user } = useAuth();
  const impersonationData = JSON.parse(localStorage.getItem('impersonation') || 'null');
  
  // Hide banner if no impersonation OR if the stored impersonation target does NOT
  // match the currently logged-in user (stale data from a previous session)
  if (!impersonationData || !impersonationData.isImpersonated) {
    return null;
  }
  
  const targetEmail = impersonationData.targetUser?.email?.toLowerCase();
  const currentEmail = user?.email?.toLowerCase();
  if (!targetEmail || !currentEmail || targetEmail !== currentEmail) {
    // Stale impersonation entry — clean it up silently and don't render
    try { localStorage.removeItem('impersonation'); } catch (e) { /* no-op */ }
    return null;
  }

  const handleExitImpersonation = async () => {
    try {
      const token = localStorage.getItem('token');
      
      const loadingToast = toast.loading('Ultra Admin paneline dönülüyor...');
      
      const response = await axios.post(
        `${BACKEND_URL}/api/ultra-admin/exit-impersonation`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        // Restore Ultra Admin token
        localStorage.setItem('ultra_admin_token', response.data.access_token);
        localStorage.removeItem('token');
        localStorage.removeItem('impersonation');
        localStorage.removeItem('user');
        
        toast.dismiss(loadingToast);
        toast.success('Ultra Admin paneline dönüldü');
        
        // Redirect to Ultra Admin panel
        setTimeout(() => {
          window.location.href = '/ultra-admin/dashboard';
        }, 500);
      }
    } catch (error) {
      console.error('Exit impersonation error:', error);
      toast.error('Çıkış yapılamadı', {
        description: error.response?.data?.detail || 'Bir hata oluştu'
      });
    }
  };

  return (
    <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-white/20 p-2 rounded-full animate-pulse">
              <AlertTriangleIcon className="w-5 h-5" />
            </div>
            <div>
              <p className="font-semibold text-sm">
                🔐 Ultra Admin Modu Aktif
              </p>
              <p className="text-xs opacity-90">
                <span className="font-medium">{impersonationData.targetUser.full_name}</span> 
                {' '}({impersonationData.targetUser.email}) olarak görüntülüyorsunuz
                {' '}• {impersonationData.targetUser.company_name}
              </p>
            </div>
          </div>
          
          <button
            onClick={handleExitImpersonation}
            className="flex items-center space-x-2 bg-white text-orange-600 px-4 py-2 rounded-lg hover:bg-orange-50 transition-colors font-medium text-sm shadow-md"
          >
            <LogOutIcon className="w-4 h-4" />
            <span>Ultra Admin'e Dön</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
